import { createThemedComponent } from "./create-themed-component";
/**
 * `styled` is little more than a recreation of `createThemedComponent`, with a nicer API. It does the same thing, but looks a bit nicer to use and has a clean name 😇
 *
 * ```jsx
 * import { Text } from 'react-native'
 *
 * const MyText = styled(Text)({
 *   borderBottomStyle: 'solid',
 *   color: ['primary', 'secondary']
 * })
 * ```
 *
 */ export function styled(Component) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, themeKey = _ref.themeKey, defaultVariant = _ref.defaultVariant;
    function dripsyFactory(defaultStyle) {
        return createThemedComponent(Component, {
            defaultVariant: defaultVariant,
            themeKey: themeKey,
            defaultStyle: defaultStyle
        });
    }
    return dripsyFactory;
}
